import IconButton from '@/global/components/Button/IconButton'
import { GridCellParams } from '@/global/components/DataGrid/utils/types'
import Dialog from '@/global/guides/Dialog'
import { UserRoundMinusIcon } from 'lucide-react'
import { useState } from 'react'
import { reps } from 'service/api'
import { toast } from 'sonner'

export const DesassociarFuncionarioRep: React.FC<GridCellParams> = ({
    row,
}) => {
    const [open, setOpen] = useState(false)
    const { mutate } = reps.funcionarios.mutations.useDelete({
        invalidateQuery: true,
    })

    function handleSubmit() {
        mutate(row.id, {
            onSuccess: async () => {
                setOpen(false)
                toast.success('Funcionário desassociado com sucesso')
            },
        })
    }

    return [
        <IconButton
            key="desassociar"
            onClick={() => setOpen(true)}
            size="small"
        >
            <UserRoundMinusIcon />
        </IconButton>,
        <Dialog.Root
            open={open}
            onSubmit={handleSubmit}
            onClose={() => setOpen(false)}
        >
            <Dialog.Content>
                Deseja desassociar o funcionario a este REP?
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit />
            </Dialog.Actions>
        </Dialog.Root>,
    ]
}
